export default {
  getHouseholdInfo: (state: any) => {
    return state.enrollmentFormsContainer.household;
  },
  getProgramStatement: (state: any) => {
    return state.enrollmentFormsContainer.programStatement;
  },
  getFamilyAmenities: (state: any) => {
    return state.enrollmentFormsContainer.familyAmenities;
  },
  getHomeSafety: (state: any) => {
    return state.enrollmentFormsContainer.homeSafety;
  },
  getChildcareLocation: (state: any) => {
    return state.enrollmentFormsContainer.location;
  },
  getParentBookingMethod: (state: any) => {
    return state.enrollmentFormsContainer.parentBookWithApprovalRequest;
  },
  getAvailabilitySettings: (state: any) => {
    return state.enrollmentFormsContainer.availabilitySettings;
  },
  getAcceptedAgeGroups: (state: any) => {
    return state.enrollmentFormsContainer.acceptedAgeGroups;
  },
  getHoursOfBusiness: (state: any) => {
    return state.enrollmentFormsContainer.hoursOfBusiness;
  },
  getPrices:(state: any) => {
    return state.enrollmentFormsContainer.prices;
  },
  getCancellationOptions: (state: any) => {
    return state.enrollmentFormsContainer.cancellationOptions;
  },
  getPolicies: (state: any) => {
    return state.enrollmentFormsContainer.policies;
  },
  getNotifications: (state: any) => {
    return state.enrollmentFormsContainer.notifications;
  },
  getBadges: (state: any) => {
    return state.enrollmentFormsContainer.badges;
  },
  getChildcareEnrollmentStep: (state: any) => {
    return state.enrollmentFormsContainer.childcareEnrollmentStep;
  },
  getRefreshChildrenList: (state: any) => {
    return state.refreshChildrenList;
  },
  getUpdateFamilyMembers: (state: any) => {
    return state.updateFamilyMembers;
  },
  getProviderForCurrentUser: (state: any) => {
    return state.providerForCurrentUser;
  },
  getAcceptBooking: (state: any) => {
    return state.acceptBooking;
  },
  getRejectBooking: (state: any) => {
    return state.rejectBooking;
  },
}